(function () {
  var billingForm = document.querySelector('#billingaddress-form');
  if (!billingForm) return;

  var submitBtn = billingForm.querySelector('.billingaddress-submit');
  var successEl = document.getElementById('success_msg_ba');
  var errorList = document.getElementById('billingaddressFormSubmitError');
  var allInputs = billingForm.querySelectorAll('input, select, textarea');

  function setSubmitting(state) {
    if (submitBtn) submitBtn.disabled = !!state;
  }

  function clearFieldError(target) {
    var err = target.parentNode && target.parentNode.querySelector('.form-field-error');
    if (err) err.innerText = '';
  }

  function showFieldError(target) {
    var err = target.parentNode && target.parentNode.querySelector('.form-field-error');
    if (!err) return;
    var label = target.dataset.errorLabel || 'This field';
    if (target.value === '') {
      err.innerText = label + ' is required';
    } else {
      err.innerText = 'You have to enter a valid ' + label;
    }
  }

  billingForm.addEventListener(
    'invalid',
    function (e) {
      e.preventDefault();
      showFieldError(e.target);
    },
    true
  );

  allInputs.forEach(function (ele) {
    ele.addEventListener('input', function (e) {
      clearFieldError(e.target);
    });
    ele.addEventListener('change', function (e) {
      clearFieldError(e.target);
    });
  });

  var phoneInput = document.getElementById('billingaddressPhone');
  if (phoneInput) {
    phoneInput.addEventListener('input', function () {
      var digits = this.value.replace(/[^0-9]/g, '').slice(0, 10);
      if (digits.length >= 7) {
        this.value = digits.replace(/(\d{3})(\d{3})(\d+)/, '$1-$2-$3');
      } else if (digits.length >= 4) {
        this.value = digits.replace(/(\d{3})(\d+)/, '$1-$2');
      } else {
        this.value = digits;
      }
    });
  }

  billingForm.addEventListener('submit', function (e) {
    e.preventDefault();
    if (errorList) errorList.innerHTML = '';
    if (successEl) successEl.innerHTML = '';
    setSubmitting(true);

    var formData = new URLSearchParams(new FormData(billingForm));

    fetch('https://modway-custom-app-prod.azurewebsites.net/api/createbillingaddressform', {
      method: 'POST',
      body: formData,
    })
      .then(function (response) {
        return response.text();
      })
      .then(function (text) {
        var data;
        try {
          data = JSON.parse(text);
        } catch (err) {
          data = null;
        }

        if (data && data.status && data.rows) {
          var row = data.rows;
          var digits = (row.phone || '').replace(/[^0-9]/g, '').slice(0, 10);
          var formattedPhone = digits.length === 10
            ? digits.replace(/(\d{3})(\d{3})(\d+)/, '$1-$2-$3')
            : row.phone || '';

          var fields = {
            billingaddressFName: row.first_name,
            billingaddressLName: row.last_name,
            billingaddressCompany: row.company,
            billingaddressAddress1: row.address1,
            billingaddressAddress2: row.address2,
            billingaddressCity: row.city,
            billingaddressCountry: row.country_code,
            billingaddressState: row.province_code,
            billingaddressZip: row.zip,
            billingaddressPhone: formattedPhone,
          };

          Object.keys(fields).forEach(function (id) {
            var el = document.getElementById(id);
            if (el && fields[id] != null) el.value = fields[id];
          });

          if (successEl) successEl.innerText = 'Billing address updated successfully.';
        } else if (errorList) {
          var msg = (data && data.message) || 'Something went wrong. Please try again.';
          var li = document.createElement('li');
          li.innerText = msg;
          errorList.appendChild(li);
        }
      })
      .catch(function () {
        if (errorList) {
          var li = document.createElement('li');
          li.innerText = 'Network error. Please try again.';
          errorList.appendChild(li);
        }
      })
      .then(function () {
        setSubmitting(false);
      });
  });
})();
